var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { BaseNumberIdDataDto } from '../../../classes/common/response/base-number-id-data.dto';
import { VehicleWithVehicleModelDto } from '../../../classes/vehicle/response/vehicle-with-vehicle-model.dto';
import { PreallocationWithoutRelationsDto } from '../../preallocation/response/preallocation-without-relations.dto';
export class PreallocationBlockDto extends BaseNumberIdDataDto {
    constructor(initializer) {
        super(initializer);
        this.vehicle = initializer.vehicle;
        this.vehicleId = initializer.vehicleId;
        this.startDate = initializer.startDate;
        this.endDate = initializer.endDate;
        this.preallocationId = initializer.preallocationId;
        this.preallocation = initializer.preallocation;
    }
}
__decorate([
    Type(() => VehicleWithVehicleModelDto),
    __metadata("design:type", VehicleWithVehicleModelDto)
], PreallocationBlockDto.prototype, "vehicle", void 0);
__decorate([
    Type(() => Date),
    __metadata("design:type", Date)
], PreallocationBlockDto.prototype, "startDate", void 0);
__decorate([
    Type(() => Date),
    __metadata("design:type", Date)
], PreallocationBlockDto.prototype, "endDate", void 0);
__decorate([
    Type(() => PreallocationWithoutRelationsDto),
    __metadata("design:type", PreallocationWithoutRelationsDto)
], PreallocationBlockDto.prototype, "preallocation", void 0);
